<app-header></app-header>
<div class="right-side p-5">
  <h1>Submit New Proposal</h1>
  <div class="section">
    <form [formGroup]="form">
      <div class="card mb-3">
        <div class="card-header"> <h2>Proposal Details</h2></div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-4">
              <label class="nowrap">Event Name</label>
              <input type="text" autocomplete="off" id="txteventName" class="form-control" formControlName="EventName"
                     placeholder="Event Name">
              <!--<div *ngIf="f['Name'].touched && f['Name'].invalid" class="alert alert-danger">
        <div *ngIf="f['Name'].errors && f['Name'].errors['required']">
          Name is required
        </div>
        <div *ngIf="f['Name'].errors && f['Name'].errors['minlength']">
          Minimum length should be 3 characters
        </div>
        <div *ngIf="f['Name'].errors && f['Name'].errors['maxlength']">
          Maximum length should be 100 characters
        </div>
        <div *ngIf="f['Name'].errors && f['Name'].errors['pattern']">
          Name should not contain digits or special characters
        </div>
      </div>-->
            </div>
            <div class="col-md-4">
              <label class="nowrap">Type of component</label>
              <input type="text" autocomplete="off" id="txttypeOfComponent" class="form-control" formControlName="TypeOfComponent"
                     placeholder="Type of Component">
              <!--<div *ngIf="f['NameOfEnterprise'].touched && f['NameOfEnterprise'].invalid" class="alert alert-danger">
        <div *ngIf="f['NameOfEnterprise'].errors && f['NameOfEnterprise'].errors['required']">
          Enterprise name is required
        </div>
        <div *ngIf="f['NameOfEnterprise'].errors && f['NameOfEnterprise'].errors['minlength']">
          Minimum length should be 3 characters
        </div>
        <div *ngIf="f['NameOfEnterprise'].errors && f['NameOfEnterprise'].errors['maxlength']">
          Maximum length should be 100 characters
        </div>
      </div>-->
            </div>
            <div class="col-md-4">
              <label class="nowrap">Date of submission</label>
              <input type="date" autocomplete="off" id="txtdateOfSubmission" class="form-control" formControlName="DateOfSubmisison"
                     placeholder="Date of Submission">
              <!--<div *ngIf="f['TypeOfOrganization'].touched && f['TypeOfOrganization'].invalid" class="alert alert-danger">
        <div *ngIf="f['TypeOfOrganization'].errors && f['TypeOfOrganization'].errors['required']">
          Organization Name is required
        </div>
        <div *ngIf="f['TypeOfOrganization'].errors && f['TypeOfOrganization'].errors['minlength']">
          Minimum length should be 3 characters
        </div>
        <div *ngIf="f['TypeOfOrganization'].errors && f['TypeOfOrganization'].errors['maxlength']">
          Maximum length should be 50 characters
        </div>
      </div>-->
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <label class="nowrap">Intervention</label>
              <input type="text" autocomplete="off" id="txtintervention" class="form-control" formControlName="Intervention"
                     placeholder="Intervention Name" maxlength="10">
              <!--<div *ngIf="f['OwnersMobileNumber'].touched && f['OwnersMobileNumber'].invalid" class="alert alert-danger">
        <div *ngIf="f['OwnersMobileNumber'].errors && f['OwnersMobileNumber'].errors['required']">
          Owner mobile Number is required
        </div>
        <div *ngIf="f['OwnersMobileNumber'].errors && f['OwnersMobileNumber'].errors['minlength']">
          Length should be 3 characters
        </div>
        <div *ngIf="f['OwnersMobileNumber'].errors && f['OwnersMobileNumber'].errors['pattern']">
          Mobile number should be 10 digits only, first digit should be non zero
        </div>
      </div>-->
            </div>
            <div class="col-md-4">
              <label class="nowrap">Sitting Capacity</label>
              <input type="text" autocomplete="off" id="txtsittingCapacity" class="form-control" formControlName="SittingCapacity"
                     placeholder="Sitting Capacity" maxlength="10">
              <!--<div *ngIf="f['AlternateContactNumber'].touched && f['AlternateContactNumber'].invalid" class="alert alert-danger">
        <div *ngIf="f['AlternateContactNumber'].errors && f['AlternateContactNumber'].errors['required']">
          Alternate contact Number is required
        </div>
        <div *ngIf="f['AlternateContactNumber'].errors && f['AlternateContactNumber'].errors['minlength']">
          Length should be 3 characters
        </div>
        <div *ngIf="f['AlternateContactNumber'].errors && f['AlternateContactNumber'].errors['pattern']">
          Mobile number should be 10 digits only, first digit should be non zero
        </div>
      </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Instructor Details</h2></div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-4">
              <label class="nowrap">Instructor Name</label>
              <input type="text" autocomplete="off" id="txtinstructorName" class="form-control" formControlName="InstructorName"
                     placeholder="Name of Instructor">
              <!--<div *ngIf="f['SocialCategory'].touched && f['SocialCategory'].invalid" class="alert alert-danger">
        <div *ngIf="f['SocialCategory'].errors && f['SocialCategory'].errors['required']">
          Social Category is required
        </div>
        <div *ngIf="f['SocialCategory'].errors && f['SocialCategory'].errors['minlength']">
          Length should be 3 characters
        </div>
        <div *ngIf="f['SocialCategory'].errors && f['SocialCategory'].errors['maxlength']">
          Length should be 50 characters
        </div>
      </div>-->
            </div>
            <div class="col-md-4">
              <label class="nowrap">Designation</label>
              <input type="text" autocomplete="off" id="txtinstructorDesignation" class="form-control" formControlName="InstructorDesignation"
                     placeholder="Designation of Instructor">
              <!--<div *ngIf="f['NICCode'].touched && f['NICCode'].invalid" class="alert alert-danger">
        <div *ngIf="f['NICCode'].errors && f['NICCode'].errors['required']">
          NIC Code is required
        </div>
        <div *ngIf="f['NICCode'].errors && f['NICCode'].errors['minlength']">
          Minimum length should be 3 characters
        </div>
        <div *ngIf="f['NICCode'].errors && f['NICCode'].errors['maxlength']">
          Length should be 10 characters
        </div>
      </div>-->
            </div>
          </div>
        </div>
      </div>
     
      <div class="card mb-3">
        <div class="card-header"> <h2>Add your Details here</h2></div>
        <div class="card-body">
          <div class="text-center">
            <button id="btnsubmitProposal" (click)="SubmitProposal()" class="btn btn-success me-2">Submit</button>
            <button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger">Cancel</button>
          </div>
        </div>
      </div>
     
     
      
    </form>
  </div>
</div>
<app-footer></app-footer>


